import React from 'react';
import get from 'lodash/get';
import './styles.css';

const Footer = (props) => (
  <div className="quick-invoice-footer">
    {get(props, 'note', '')}
  </div>
);

export default Footer;
